export default __webpack_public_path__ + "static/media/TramaNacena.b7e7b205.png";